import { loadScript, removeScripts } from 'common-utils';

import { Events } from '../tracking-events/event';
import {
  PageView,
  TrackEvent,
  TrackingTool,
  UserDetails,
} from '../tracking-tool';
import { TrackingProperties } from '../use-tracking';

export enum ClevertapEvent {
  MOBILE_TO_DESKTOP_EMAIL = 'MOBILE_TO_DESKTOP_EMAIL',
}

enum PreflightEventCategory {
  'Manuscript upload intent',
  'Manuscript upload completion',
  'Report generation status',
  'Payment intent',
  'Payment completion',
}

const discoveryPublisherAllowedEvents = [
  'Click to Track - Discovery B2B',
  'Click to track',
  'Publisher Dashboard Section Viewed',
  'Input Intent',
];
const allowedDiscoveryEventTypes = [
  'Click to track',
  'Visibility',
  'Navigation Used',
  'GetFTR institute selected',
  'Feedback success',
  'click to track',
  'User Details',
  'UnBookmark',
  'UnBookmark Failed',
  'Tag Click',
  'Tag click',
  'Share Success',
  'Share Intent',
  'Institute selected and saved',
  'Feedback Success',
  'feedback',
  'Click to Track',
  'Click to track - R Life',
  'Click to track - Discovery',
  'Auto sync not available',
  'Article rank in search',
  'Input intent',
  'Input focused',
  'Translation Success',
  'Translation Error',
  'Translate Intent',
  'Language Selection',
  'delete-article',
  'New Note Created',
  'Intent_to_view_Highlights_Summary',
  'Goal tracking',
  'paperpal-citation',
  'create-save',
];
const allowedEventTypes = [
  'Page Viewed',
  'sign-up',
  'login-in',
  'change-password',
  'file-upload',
  'file-upload-failed',
  'payment',
  'login-in-failed',
  'change-password-intent',
  'change-password-failed',
  'login-in-intent',
  'sign-up-failed',
  'sign-up-intent',
  'click-to-track-paperpal',
  'view-to-track-paperpal',
  'PP-first-time-use',
  'search_paperpal',
  'captcha',
  'manuscript_upload',
  'payment-success-page-viewed',
  'PP-LS-first-time-use',
  'paywall_hit',
  ...discoveryPublisherAllowedEvents,
  ...allowedDiscoveryEventTypes,
];

export class Clevertap implements TrackingTool {
  private _id: string;

  constructor(id: string) {
    this._id = id;
  }

  async trackEvent({ action, category, label, customData }: TrackEvent) {
    if (customData === undefined || customData === null) {
      window.clevertap.event.push(action + category + label);
    } else {
      //Add additional properties in clevertap if available.
      if (customData.ProductName === 'paperpal-preflight') {
        const values = Object.values(PreflightEventCategory);
        if (values.includes(category as unknown as PreflightEventCategory)) {
          window.clevertap.event.push(category, customData);
        }
      } else {
        //Add additional properties in clevertap if avialable.
        window.clevertap.event.push(action + category + label, customData);
      }
    }
  }

  async trackCommonEvent(event: Events, properties?: TrackingProperties) {
    if (allowedEventTypes.includes(event.type)) {
      const { type, ...eventData } = event;
      const { disableGa4Tracking, ...cleanProperties } = properties || {};
      window.clevertap.event.push(type, {
        ...eventData,
        ...cleanProperties,
      });
    }
  }

  async turnOff() {
    removeScripts([
      'https://d2r1yp2w7bby2u.cloudfront.net/js/clevertap.min.js',
      'http://static.clevertap.com/js/clevertap.min.js',
    ]);
  }

  async turnOn() {
    if (typeof window !== 'undefined') {
      window.clevertap = {
        /* eslint-disable  @typescript-eslint/no-explicit-any */
        event: [] as any,
        profile: [] as any,
        account: [] as any,
        onUserLogin: [] as any,
        notifications: [] as any,
        privacy: [] as any,
      } as any;
      (window.clevertap as any).account.push({ id: this._id });
      window.clevertap.privacy.push({ optOut: false });
      window.clevertap.privacy.push({ useIP: true });
      window.clevertap.spa = true;

      const src = `${
        'https:' === document.location.protocol
          ? 'https://d2r1yp2w7bby2u.cloudfront.net'
          : 'http://static.clevertap.com'
      }/js/clevertap.min.js`;
      await loadScript(src);
    }
  }

  getName(): string {
    return 'clevertap';
  }

  trackSpecialEvent = {
    signIn: async (userDetails: UserDetails) => {
      window.clevertap.onUserLogin.push({
        Site: {
          Name: userDetails.name,
          Identity: userDetails.ssoId,
          Email: userDetails.email,
        },
      });
    },
    onUserCreated: async () => {},
    pageView: async (pageView: Partial<PageView>) => {
      window.clevertap.event.push('Page Viewed', {
        ProductName: pageView.productName,
        JournalName: pageView.journalName,
        PublisherName: pageView.publisherName,
        FlowType: pageView.flowType,
        AnonymousOrSignedIn: pageView.anonymousOrSignedIn,
        PageURL: pageView.pageURL,
        SourceURL: pageView.sourceURL,
        Ip: pageView.ip,
        PageTitle: pageView.pageTitle,
        utm_source: pageView.utm_source,
        utm_medium: pageView.utm_medium,
        utm_campaign: pageView.utm_campaign,
        device: pageView.device,
      });
    },
  };
}
